'use client';

import Script from 'next/script';
import { SITE } from '@/app/constants';

// 海外转化ID
const BING_CONVERSION_ID_GLOBAL = '187194568';
// 国内转化ID
const BING_CONVERSION_ID_CHINA = '187228735';

// 埋点需求文档：https://bingadsuet.azurewebsites.net/UETDirectOnSite_ReportVariableRevenue.html

export function BingPixel() {
  const conversionId = SITE === 'china' ? BING_CONVERSION_ID_CHINA : BING_CONVERSION_ID_GLOBAL;

  return (
    <Script id="bing-uet-tag" strategy="lazyOnload">
      {`
        (function(w,d,t,r,u)
        {
          var f,n,i;
          w[u]=w[u]||[],f=function()
          {
            var o={ti:"${conversionId}", enableAutoSpaTracking: true};
            o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")
          },
          n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function()
          {
            var s=this.readyState;
            s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)
          },
          i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)
        })
        (window,document,"script","//bat.bing.com/bat.js","uetq");
        `}
    </Script>
  );
}
